import { Promocion } from "../../firebase/firestore/promociones";
import FormPromocion from "../promociones/FormPromocion";
import Modal from "./Modal";

export default function ModalFormPromocion({
  entity,
  isOpen,
  onClose,
}: {
  entity?: Promocion;
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={entity ? "Editar promoción" : "Crear promoción"}
      content={<FormPromocion onClose={onClose} entity={entity} />}
    />
  );
}
